import axios from 'axios';
import { BASE_URL } from './constants';
// import * as qs from 'qs';

export const getCertificate = (id) => {
  return axios.get(`${BASE_URL}/api/certificate/${id}`);
};
